/* eslint-disable no-unused-vars */
import { useState } from "react"
import {
  Tooltip,
  Grid,
  // FormControl,
  TextField,
  // InputLabel,
  // Select,
  // MenuItem,
  // Checkbox,
  // ListItemText,
} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import {
  // obtenerHotelesByIdPaqueteAction,
  altaHotelCatalogAction,
} from "./../../../ducks/hotelDuck"
// import { altaHotelPaqueteAction } from "./../../../ducks/paqueteDuck"
import useCatalogo from "../../../hooks/useCatalogos"
import { FPaquetesStyle } from "./styles"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { crearHotelPaqueteTerrestre, obtenerHotelelesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}
const AltaHotel = (props) => {
  const { origen } = props
  const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)
  const classes = FPaquetesStyle()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [nombre, setNombre] = useState("")
  const [isLoad, setIsload] = useState(false)
  const [servicios, setServicios] = useState([])
  const catServicios = useCatalogo("Servicio")

  const handleClickOpen = () => {
    setOpen(true)
    LimpiarForm()
  }
  const handleClose = () => {
    setOpen(false)
    LimpiarForm()
  }
  const onGuardar = () => {
    setIsload(true);
    let payload = {
      IdOrigen: origen.IdCiudad,
      Descripcion: nombre,
    }
    dispatch(altaHotelCatalogAction(payload)).then((Response) => {
      if (Response.status === 500) {
        ToastMessage.fire({
          icon: "error",
          title: "Ha habido un problema de conexión con el servidor",
        })
        return
      }
      if (Response.status === 400) {
        ToastMessage.fire({
          icon: "warning",
          title: "<strong>Atención</strong>",
          text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
        })
        return
      }
      let hotel = {
        idPaqueteTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre,
        idHotel: Response.data,
        suplemento: 0,
      }
      dispatch(onLoadAnction({ message: "" }))
      dispatch(crearHotelPaqueteTerrestre(hotel)).then((respueta) => {
        dispatch(offLoadAction())
        setOpen(false)
        dispatch(obtenerHotelelesPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect.IdPaqueteProveedorTerrestre }))
        ToastMessage.fire({
          icon: "success",
          title: "Exito en la operacion",
        });
      })
    })
  }
  const getIdServicios = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.IdServicio;
    });
  }
  const LimpiarForm = () => {
    setNombre("");
    setServicios([]);
  }
  const getDescripcion = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.Descripcion;
    });
  }
  const handleChange = (event) => {
    setServicios(event.target.value);
  }

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
      <Tooltip title="Agregar hotel">
        <span>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpen}
            disabled={origen.IdCiudad > 0 ? false : true}
            style={{
              height: "3.5rem",
              width: "4.5rem"
            }}
          >
            <AddCircleOutlineIcon />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Nuevo hotel</DialogTitle>
        
        <DialogContent>
          <DialogContentText>{origen.Nombre}</DialogContentText>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                required
                id="input-Nombre"
                label="Nombre"
                type="text"
                variant="outlined"
                name="nombre"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                className={classes.textField}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onGuardar}
            color="primary"
            disabled={nombre.length > 0 ? false : true}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default AltaHotel
